import { FC } from "react";
import "./styles/reset.scss";
import {
  BrowserRouter as Router
} from "react-router-dom";
import { AuthProvider } from "./components/common";
import { DynamicRoutes } from "./router/dynamicRoutes";

interface Props {}
export const App: FC<Props> = () => {
  return (
    <Router>
      <AuthProvider>
        <DynamicRoutes />
      </AuthProvider>
    </Router>
  );
};
